__turbopack_context__.v({
  "container": "WhenToGoSection-module__qdIwgG__container",
  "description": "WhenToGoSection-module__qdIwgG__description",
  "imageContent": "WhenToGoSection-module__qdIwgG__imageContent",
  "imageWrapper": "WhenToGoSection-module__qdIwgG__imageWrapper",
  "listMarker": "WhenToGoSection-module__qdIwgG__listMarker",
  "mainContainer": "WhenToGoSection-module__qdIwgG__mainContainer",
  "textContent": "WhenToGoSection-module__qdIwgG__textContent",
  "textOverlay": "WhenToGoSection-module__qdIwgG__textOverlay",
});
